import React, { useEffect, useState } from "react";

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  const [localDate, setLocalDate] = useState<string>("");

  const generateCopyright = (): string => {
    return "2005";
  };

  useEffect(() => {
    setLocalDate(new Date().getFullYear().toString());
  }, []);

  return (
    <footer className={className}>
      <p>
        © {localDate} MeteoMediocre - We take no responsibility for ruined
        picnics, canceled flights, or general weather-induced misery.
      </p>
      <p className="mt-2">
        <a href="#" className="text-blue-500 hover:underline">
          Terms of Misery
        </a>{" "}
        |
        <a href="#" className="ml-2 text-blue-500 hover:underline">
          Privacy Policy
        </a>{" "}
        |
        <a href="#" className="ml-2 text-blue-500 hover:underline">
          Contact Us (but we won't help)
        </a>
      </p>
    </footer>
  );
};

export default Footer;
